var map = {
	"./add.svg": "./src/icons/svg/add.svg",
	"./alter_delete.svg": "./src/icons/svg/alter_delete.svg",
	"./dashboard.svg": "./src/icons/svg/dashboard.svg",
	"./dataMgt.svg": "./src/icons/svg/dataMgt.svg",
	"./directionLeft.svg": "./src/icons/svg/directionLeft.svg",
	"./disabled.svg": "./src/icons/svg/disabled.svg",
	"./down.svg": "./src/icons/svg/down.svg",
	"./enabled.svg": "./src/icons/svg/enabled.svg",
	"./filedownload.svg": "./src/icons/svg/filedownload.svg",
	"./home.svg": "./src/icons/svg/home.svg",
	"./log-out.svg": "./src/icons/svg/log-out.svg",
	"./lossDetail.svg": "./src/icons/svg/lossDetail.svg",
	"./lossMgt.svg": "./src/icons/svg/lossMgt.svg",
	"./permission.svg": "./src/icons/svg/permission.svg",
	"./questionMgt.svg": "./src/icons/svg/questionMgt.svg",
	"./report.svg": "./src/icons/svg/report.svg",
	"./search.svg": "./src/icons/svg/search.svg",
	"./select.svg": "./src/icons/svg/select.svg",
	"./setting.svg": "./src/icons/svg/setting.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./user1.svg": "./src/icons/svg/user1.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";